export default __webpack_public_path__ + "static/media/Feedback-rafiki-2.52af3d44.svg";